import { render, staticRenderFns } from "./BotPickerPage.vue?vue&type=template&id=a0ed46aa"
import script from "./BotPickerPage.vue?vue&type=script&lang=js"
export * from "./BotPickerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports